import { Grid, Typography, Box, Card, CardContent } from "@mui/material";
import React from "react";
import { motion } from 'framer-motion';
import banner from "../../images/commerse.jpg";

const subjects = [
  {
    title: "Commerce with Maths",
    points: ["Best for CA, CFA, Actuarial Science, and Finance careers."],
  },
  {
    title: "Commerce with Computer Science",
    points: ["Ideal for FinTech, Data Analytics, and Digital Marketing."],
  },
  {
    title: "Commerce with Entrepreneurship",
    points: ["Helps in business development and startups."],
  },
];

const SubjectsList = () => {
  return (
    <Box sx={{ padding: { xs: 4, sm: 6, md: 8 }, background: '#fff' }}>
      <Typography
        variant="h3"
        sx={{
          fontSize: { md: "40px", xs: "32px", sm: "36px" },
          fontWeight: 800,
          color: "var(--primary-dark)",
          mb: 6,
          textAlign: "center"
        }}
      >
        Commerce with Additional Combinations
      </Typography>

      <Grid container spacing={6} alignItems="center">
        {/* Image Section */}
        <Grid item xs={12} md={5} display="flex" justifyContent="center">
          <motion.div
            initial={{ opacity: 0, x: -30 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
            style={{ width: '100%' }}
          >
            <Box
              sx={{
                width: '100%',
                borderRadius: '24px',
                overflow: 'hidden',
                boxShadow: '0 20px 40px rgba(0,0,0,0.1)',
                position: 'relative'
              }}
            >
              <img
                src={banner}
                alt="Commerce Subject Combinations"
                style={{ width: "100%", height: "auto", display: 'block', objectFit: "cover" }}
              />
            </Box>
          </motion.div>
        </Grid>

        {/* Text Section */}
        <Grid item xs={12} md={7}>
          <Grid container spacing={3}>
            {subjects.map((subject, index) => (
              <Grid item xs={12} key={index}>
                <motion.div
                  initial={{ opacity: 0, y: 20 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  viewport={{ once: true }}
                  transition={{ delay: index * 0.15, duration: 0.5 }}
                >
                  <Card className="glass-card" sx={{ borderRadius: '16px', border: '1px solid rgba(26, 35, 126, 0.1)', background: 'var(--background-light)', boxShadow: 'none' }}>
                    <CardContent sx={{ p: 4 }}>
                      <Typography variant="h5" sx={{ color: "var(--primary-color)", fontWeight: 700, mb: 1.5 }}>
                        {index + 1}. {subject.title}
                      </Typography>
                      {subject.points.map((point, i) => (
                        <Typography key={i} variant="body1" sx={{ color: "var(--text-secondary)", lineHeight: 1.6 }}>
                          • {point}
                        </Typography>
                      ))}
                    </CardContent>
                  </Card>
                </motion.div>
              </Grid>
            ))}
          </Grid>
        </Grid>
      </Grid>
    </Box>
  );
};

export default SubjectsList;
